/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;
	const thisSearch = location.search;
	let thisParam = [];
	if(thisSearch) { thisParam = thisSearch.replace(/\?/, '').split('&'); }
	let thisLat, thisLon, thisMax, thisZoom, thisCity, thisKeyword;
	let currentPin = $path.includes('/mens/') === true ? '/images/shop/current_mens.webp' : '/images/shop/current.webp';

	// JSON取得 ===============================================
	// 県別店舗一覧
	const getJSONshopLists = (_pref) => {
		return `/ajax/shop/map/${_pref}/pref.json`;
	}
	const getJSONshopListsMens = (_pref) => {
		return `/mens/ajax/shop/map/${_pref}/pref.json`;
	}
	// 現在地周辺店舗一覧
	const getJSONshopListsPoint = (_param) => {
		return `/ajax/shop/map/search.json${_param}`;
	}
	const getJSONshopListsPointMens = (_param) => {
		return `/mens/ajax/shop/map/search.json${_param}`;
	}


	// ============ ↓↓ FUNCTIONS ↓↓ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const maxToZoom = (_max) => {
		let zoom;
		if(FUNCTIONS.va.window.width > 768) {
			switch(_max) {
			case'1000000': zoom = 5; break;
			case'500000': zoom = 6; break;
			case'200000': zoom = 7; break;
			case'150000': zoom = 8; break;
			case'100000': zoom = 9; break;
			case'50000': zoom = 10; break;
			case'20000': zoom = 11; break;
			case'10000': zoom = 12; break;
			case'5000': zoom = 13; break;
			case'2000': zoom = 14; break;
			case'1000': zoom = 15; break;
			case'500': zoom = 16; break;
			case'200': zoom = 17; break;
			case'100': zoom = 18; break;
			case'50': zoom = 19; break;
			case'20': zoom = 20; break;
			case'10': zoom = 21; break;
			default: zoom = 12; break;
			}
		} else {
			switch(_max) {
			case'1000000': zoom = 4; break;
			case'500000': zoom = 5; break;
			case'200000': zoom = 6; break;
			case'150000': zoom = 7; break;
			case'100000': zoom = 8; break;
			case'50000': zoom = 9; break;
			case'20000': zoom = 10; break;
			case'10000': zoom = 11; break;
			case'5000': zoom = 12; break;
			case'2000': zoom = 13; break;
			case'1000': zoom = 14; break;
			case'500': zoom = 15; break;
			case'200': zoom = 16; break;
			case'100': zoom = 17; break;
			case'50': zoom = 18; break;
			case'20': zoom = 19; break;
			case'10': zoom = 20; break;
			default: zoom = 12; break;
			}
		}
		return zoom;
	};

	// 検索パラメータを変数にセット
	const setParamForMap = () => {
		for(let i=0; i<thisParam.length; i++) {
			switch(thisParam[i].split('=')[0]) {
			case'p_lat': thisLat = Number(thisParam[i].split('=')[1]); break;
			case'p_lon': thisLon = Number(thisParam[i].split('=')[1]); break;
			case'p_max': thisMax = Number(thisParam[i].split('=')[1]); thisZoom = maxToZoom(thisParam[i].split('=')[1]); break;
			default:
			}
		}
		if(!thisZoom) { thisZoom = 12; }
	};

	// 検索パラメータ引き継ぎ
	const setParam = () => {
		// 緯度経度、範囲意外の絞り込みパラメータとキーワードのみ引き継ぎする
		let newParam = '';
		for(let i=0; i<thisParam.length; i++) {
			if(thisParam[i].split('=')[0] !== 'p_lat' &&
				thisParam[i].split('=')[0] !== 'p_lon' &&
				thisParam[i].split('=')[0] !== 'p_max') {
				newParam += `&${thisParam[i].split('=')[0]}=${thisParam[i].split('=')[1]}`;
			}
		}
		return newParam;
	};

	// 検索結果一覧から店舗情報を取得しマーカーを立てる
	const setMarker = async (_map) => {
		// 県コード
		const prefCode = $path.split('/')[$path.split('/').length-2];
		let jsonUrl = $path.includes('/mens/') === true ? getJSONshopListsMens(prefCode) : getJSONshopLists(prefCode);
		// ポップアップのテンプレート
		let componentsPopup = await fetch('/cnt_common/js/html/shop-map-popup.html').then(res => res.text());
		if($path.includes('/common/guide/') === true) {
			componentsPopup = await fetch('/cnt_common/js/html/shop-map-popup-lp.html').then(res => res.text());
		}
		
		// 位置情報データを確実に取得してからフェッチを実行する
		const setupFetchWithPosition = (_map) => {
			// 位置情報データが確認できてからフェッチを実行する
			fetch(jsonUrl)
				.then(response => response.json())
				.then(data => {
					const marker = [];
					let $result = data.rt_bn_shop_list_json;
					if($path.split('/')[$path.split('/').length - 1] === 'result_point.html') {
						$result = data.rt_bn_shop_serch_json;
					}
					let latLngBounds = new google.maps.LatLngBounds();

					for(let i = 0; i < $result.length; i++) {
						let markerLatLng = new google.maps.LatLng({
							lat: Number($result[i].cf_s_latitude),
							lng: Number($result[i].cf_s_longitude)
						});
						latLngBounds.extend(markerLatLng);
						let markerIconPath = '/images/shop/pin.webp';
						let markerIconZindex = 1;
						marker[i] = new google.maps.Marker({
							position: markerLatLng,
							map: _map,
							icon: new google.maps.MarkerImage(markerIconPath),
							zIndex: markerIconZindex
						});

						// 店舗情報のHTML
						marker[i].addListener('click', () => {
							console.log('click!');
							let chipHTML = '';
							let shopArea = $result[i].cf_s_area._key;
							let shopPref = $result[i].cf_s_prefecture._key;
							let shopName = $result[i].cf_s_title;
							let shopAddress = $result[i].cf_s_address;
							let shopLink = $path.includes('/mens/') === true ? 
								`/mens/shop/${shopArea}/${shopPref}/${$result[i]._key}.html` : 
								`/shop/${shopArea}/${shopPref}/${$result[i]._key}.html`;

							if ($path.includes('/common/guide/tbc/') === true) {
								shopLink = `https://www.google.co.jp/maps/search/${encodeURIComponent('エステティックTBC+' + shopName)}/@${$result[i].cf_s_latitude},${$result[i].cf_s_longitude},17z`;
							} else if ($path.includes('/common/guide/mens/') === true) {
								shopLink = `https://www.google.co.jp/maps/search/${encodeURIComponent('MEN’S+TBC+' + shopName)}/@${$result[i].cf_s_latitude},${$result[i].cf_s_longitude},17z`;
							}
							
							chipHTML = componentsPopup
								.replaceAll('{!shopName!}', shopName)
								.replaceAll('{!shopAddress!}', shopAddress)
								.replaceAll('{!shopLink!}', shopLink);

							// マーカークリック時に表示する情報ウィンドウを作成
							const infoWindow = new google.maps.InfoWindow({
								content: chipHTML,
								maxWidth: 300
							});

							// 情報ウィンドウを管理するグローバル配列を作成
							if (!window.openInfoWindows) window.openInfoWindows = [];

							// 新しいウィンドウを開く前に、既存のすべての情報ウィンドウを閉じる
							window.openInfoWindows.forEach(iw => iw.close());
							window.openInfoWindows = [];

							// この情報ウィンドウを追跡配列に追加する
							window.openInfoWindows.push(infoWindow);

							// 情報ウィンドウが開かれた後に閉じるボタンのリスナーをセットアップする
							google.maps.event.addListener(infoWindow, 'domready', () => {
								const closeButtons = document.querySelectorAll('.gm-style-iw-a .shop-map-popup .__close');
								closeButtons.forEach(button => {
									button.addEventListener('click', () => {
										infoWindow.close();
										const index = window.openInfoWindows.indexOf(infoWindow);
										if (index > -1) window.openInfoWindows.splice(index, 1);
									});
								});
							});
							
							// マーカーの上に情報ウィンドウを表示する
							infoWindow.open(_map, marker[i]);
						});
					};

					// 緯度経度の指定がなく、複数件の場合は全てのマーカーが表示されるようにズームレベルを調整する
					if(!thisLat && !thisLon && $result.length > 1) {
						if(FUNCTIONS.va.window.width > 768) {
							_map.fitBounds(latLngBounds); // padding 10px
						} else {
							_map.fitBounds(latLngBounds, 50); // padding 10px
						}
					}
				})
				.catch(error => console.error('Error fetching shop data:', error));
		};

		// 近傍検索の場合
		if($path.split('/')[$path.split('/').length - 1] === 'result_point.html') {
			let jsonParam = '';
			if(thisLat !== undefined && thisLon !== undefined && thisMax !== undefined) {
				jsonParam = `?p_lat=${thisLat}&p_lon=${thisLon}&p_max=${thisMax}`;
			}

			jsonUrl = $path.includes('/mens/') === true ? 
				getJSONshopListsPointMens(jsonParam) : 
				getJSONshopListsPoint(jsonParam);
			setupFetchWithPosition(_map);
		} else {
			// 県別検索の場合、そのままフェッチ
			setupFetchWithPosition(_map);
		}
	};

	// マップ作成
	const setMap = () => {
		const googleCliKey = 'AIzaSyAk5VKocTO3a2DTVmRiEPcs1Sw4jSw2pos';
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = `//maps.googleapis.com/maps/api/js?key=${googleCliKey}&v=quarterly&libraries=geometry`;
		script.id = 'googleApiScript';
		script.async = true;

		// 県コード
		const prefCode = $path.split('/')[$path.split('/').length-2];
		let firstItem = '';

		// 最初のアイテムを取得
		let jsonUrl = $path.includes('/mens/') === true ? getJSONshopListsMens(prefCode) : getJSONshopLists(prefCode);
		if(thisLat === undefined && thisLon === undefined && $path.split('/')[$path.split('/').length - 1] === 'result_point.html') {
			jsonUrl = $path.includes('/mens/') === true ? getJSONshopListsPointMens('?') : getJSONshopListsPoint('?');
		}
		
		
		fetch(jsonUrl)
			.then(response => response.json())
			.then(data => {
				// 現在地検索で現在地情報が無い場合
				if(thisLat === undefined && thisLon === undefined && $path.split('/')[$path.split('/').length - 1] === 'result_point.html') {
					firstItem = data.rt_bn_shop_serch_json[0];
				} else {
					// 県別検索
					firstItem = data.rt_bn_shop_list_json[0];
				}
			})
			.then(() => {
				script.onload = () => {
					const canvas = document.getElementById('map-canvas');
					const styles = [
						{
							stylers: [{ saturation: -50 }]
						},
						{
							'featureType': 'landscape',
							'elementType': 'geometry.fill',
							'stylers': [{ 'color': '#efefe4' }]
						},
						{
							'featureType': 'water',
							'stylers': [{ 'color': '#bbc1d7' }]
						}
					];

					let mapLatLng;
					if(thisLat !== undefined && thisLon !== undefined) {
						// 近傍検索
						mapLatLng = new google.maps.LatLng({ lat: thisLat, lng: thisLon });
					} else {
						// 県別
						mapLatLng = new google.maps.LatLng({
							lat: Number(firstItem.cf_s_latitude),
							lng: Number(firstItem.cf_s_longitude)
						});
					}
					
					const map = new google.maps.Map(canvas, {
						center: mapLatLng,
						zoom: thisZoom,
						styles,
						mapTypeControl: false,
						fullscreenControl: false,
						streetViewControl: false
					});

					setMarker(map);

					// 位置情報ONのとき、現在位置がMAP内ならピンを表示
					const getCurrentPos = (pos) => {
						const currentMarkerLatLng = new google.maps.LatLng({
							lat: pos.coords.latitude,
							lng: pos.coords.longitude
						});
						const currentMarker = new google.maps.Marker({
							position: currentMarkerLatLng,
							map: map,
							icon: new google.maps.MarkerImage(
								currentPin,
								new google.maps.Size(18, 22),
								new google.maps.Point(0, 0),
								new google.maps.Point(9, 9)
							)
						});
					};
					navigator.geolocation.getCurrentPosition(getCurrentPos);

					// 地図ドラッグ時・スームインアウト時に再検索
					// map.addListener('dragend', () => {
					// 	let newLatLng = map.getCenter();
					// 	// 検索範囲半径(30000m)の3/4の距離が動かされたらリロード
					// 	if(google.maps.geometry.spherical.computeDistanceBetween(mapLatLng, newLatLng) > ((thisMax / 4) * 3)) {
					// 		location.href = location.pathname+`?p_lat=${newLatLng.lat()}&p_lon=${newLatLng.lng()}&p_max=12${setParam()}`;
					// 	}
					// });
				};
				document.body.appendChild(script);
			})
			.catch(error => console.error('Error fetching shop data:', error));
	};
	// 検索結果をマップに反映
	const redirectResult = () => {
		if($path.split('/')[$path.split('/').length - 1] === 'result_point.html') {
			if($path.split('/')[3] === 'index.html') {
				// 初期表示（現在地が取得できなかった場合）
				location.href = '/shop/search/list_point.html?p_lat=35.69181&p_lon=139.695303&p_max=12';
			} else {
				// 現在地情報がある場合
				setMap();
			}
		} else {
			// 県別表示
			setMap();
		}
	};


	// ============ ↑↑ FUNCTIONS ↑↑ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	setParamForMap();
	redirectResult();

	
})(window.FUNCTIONS);
